import { ISnapshot, ISnapshotFromServer } from 'interfaces';
import { axiosAPI } from './API';

// Singleton for interacting with snapshots
class _SnapshotsService {
    private fieldNamesById = {
        deviceState: 'Update State',
        deviceStateDetail: 'State Detail',
        firmwareVersion: 'Firmware',
        lastSeen: 'Last Seen',
        location: 'Location',
        manufacturerName: 'Manufacturer',
        menuVersion: 'Menu',
        modelName: 'Model',
        serialNumber: 'Serial',
        thingId: 'ThingID',
        updateId: 'Update ID',
    }
    private cache: {[snapshotId: number]: ISnapshot} = {};

    public getSnapshot = (id: number): Promise<ISnapshot> => {
        // Cache snapshots for faster load performance because they never change.
        // Or rather, they do change in S3, but we get a new db id for them, so they look new to us.
        if (this.cache[id]) {
            return Promise.resolve(this.cache[id]);
        }

        return axiosAPI.get<ISnapshotFromServer>(`/snapshots/${id}/json`)
            .then((response) => {
                const snapshot = this.mapSnapshotFromServer(response.data);
                this.cache[id] = snapshot;
                return snapshot;
            }).catch((err) => {
                console.error('Error getting snapshot: ', err);
                throw err; // Pass error up the promise chain
            });
    }

    public getColumnLabel = (columnId: string): string => {
        return this.fieldNamesById[columnId] || columnId;
    }

    private mapSnapshotFromServer = (s: ISnapshotFromServer): ISnapshot => {
        // If there are no devices, "data" can be null. It's the Go slice json serialization thing.
        return {
            data: s.data || [],
            metadata: {
                ...s.metadata,
                dataGenerationDate: new Date(s.metadata.dataGenerationDate),
            }
        }
    }
}

export const SnapshotsService = new _SnapshotsService();